import type { OptionTypeBase } from 'react-select';

import { Select, type SelectProps } from '@frontend/components';

const PeriodPicker = <OptionType extends OptionTypeBase>(
  props: Omit<SelectProps<OptionType, false>, 'isMulti'>,
) => <Select isClearable={false} {...props} isMulti={false} />;

export default PeriodPicker;
